import { arrayMove } from '@dnd-kit/sortable';

export const swap = <T extends { id?: number; index: number }>(
  arr: Array<T>,
  activeId: number,
  overId: number,
): Array<T> => {
  const oldIndex = arr.findIndex(({ id }) => id === activeId);
  const newIndex = arr.findIndex(({ id }) => id === overId);

  // Swap elements in array
  const swappedArray = arrayMove(arr, oldIndex, newIndex);

  // Update indexes of swaped elements
  const updatedArray = swappedArray.map((el, index) => {
    return {
      ...el,
      index,
    };
  });

  return updatedArray;
};
